import {BaseEntity} from "../common/baseEntity";
/**
 * Created by alex.y on 9/11/2017.
 */
export class BaseProduct extends BaseEntity<number> {
    public Name: string;
    public HsCode: string;
}


// WEBPACK FOOTER //
// ./app/objects/products/baseProduct.ts